<!-- lazy load component -->
@if (selector) {
  <ng-container [appLazyDirective]="lazy_config" [inputs]="inputs" [outputs]="outputs" />
}
